import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { OrderDetails } from "../../../../_models/_menu/order-details";
import { OrdersService } from "src/app/_services/orders.service";
import { Location } from "@angular/common";
import { BreadcrumbService } from "../../../../_services/breadcrumb.service";
import { combineLatest } from "rxjs";

@Component({
  selector: "app-order",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.css"],
})
export class OrderComponent implements OnInit {
  menu;
  order;
  private id: any;
  filters;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrdersService,
    private location: Location,
    private bs: BreadcrumbService
  ) {
    combineLatest(this.route.params, this.route.queryParams).subscribe(
      ([params, query]) => {
        this.id = params["id"];
        this.filters = query;

        this.menu = new OrderDetails(params["id"], query);
      }
    );
  }

  ngOnInit() {
    const params = {};

    // get order details to show the name at the top
    this.orderService
      .getOrderByIdentityNumber(params, this.id)
      .subscribe((data) => {
        this.order = data.result;
      });
  }
}
